import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
//this will work for hostlistners(performance related)
export class UtilitiesService {

  constructor() { }
  private wasInside = false;
  documentScrollTarget: Subject<any> = new Subject<any>()
  documentClickedTarget: Subject<HTMLElement> = new Subject<HTMLElement>()
  documentMouseUpTarget: Subject<any> = new Subject<any>()
  documentTouchEndTarget: Subject<any> = new Subject<any>()
  documentMouseDownTarget: Subject<any> = new Subject<any>()
  documentMouseMoveTarget: Subject<any> = new Subject<any>()
  documentTouchMoveTarget: Subject<any> = new Subject<any>()
  documentMouseLeaveTarget: Subject<any> = new Subject<any>()
  documentMouseOverTarget: Subject<any> = new Subject<any>()
  documentArrowLeftTarget: Subject<any> = new Subject<any>()
  documentArrowRightTarget: Subject<any> = new Subject<any>()
  documentWindowResizeTarget: Subject<any> = new Subject<any>()
  documentTouchStartTarget: Subject<any> = new Subject<any>()
  documentTouchCancelTarget: Subject<any> = new Subject<any>()
  documentArrowUpTarget: Subject<any> = new Subject<any>()
  documentArrowDownTarget: Subject<any> = new Subject<any>()
  //documentDblclickTarget: Subject<any> = new Subject<any>()
}
